import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/**
 * אזור גלילה פנימי — `stable` תואם לרוחב המסילה הגלובלי (`SCROLLBAR_TRACK_HIT_WIDTH_PX`).
 */
export const scrollbarRegionSx: SystemStyleObject<Theme> = {
  scrollbarGutter: 'stable',
  minHeight: 0,
};
